package amazon.lastmile.inject

import app.nestbridge.feature.progress.presentation.ProgressPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ProgressPresenterFactory::class)
public interface AppNestbridgeFeatureProgressPresentationProgressPresenterFactory {
  @Provides
  @IntoSet
  public fun provideProgressPresenterFactoryFactoryMultibinding(progressPresenterFactory: ProgressPresenterFactory): Presenter.Factory = progressPresenterFactory
}
